const scrollTo = (el, offset = 100) => {
  if (!el) {
    return;
  }
  const rect = el.getBoundingClientRect();
  window.scrollTo({
    top: rect.top + window.scrollY - offset,
    behavior: 'smooth',
  });
};

export default scrollTo;
